import { render, staticRenderFns } from "./StaticCC.vue?vue&type=template&id=188ca9a2&"
import script from "./StaticCC.vue?vue&type=script&lang=js&"
export * from "./StaticCC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports